export default __webpack_public_path__ + "static/media/health-check-up.772f0dd2.svg";